<template>
  <div class="componentRoot" v-if="dailyData">
    <v-container fluid>
      <v-row>
        <v-col class="pb-0">
          <v-card flat class="dashboardCard hoverable" style="min-height: unset !important;">
            <h3>{{ $t("constants.weekday_" + weekday) }} {{ displayDate }}</h3>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="cardCols" class="pr-2 pb-0">
          <v-card class="dashboardCard hoverable" flat @click="gotoUsers($event, false)" @mousedown.middle="gotoUsers($event, true)">
            <h3>{{ $t("basics.patients") }}</h3>
            <h1><span style="color:rgb(var(--v-theme-primary))">
                {{ dailyData.patient_count }}</span> <span style="color:rgb(var(--v-theme-success))"
                v-if="dailyData.patient_count_new">+{{ dailyData.patient_count_new }}</span>
            </h1>
          </v-card>
        </v-col>
        <v-col :cols="cardCols" class="pb-0" :class="{ 'px-2': cardCols != 6, 'pl-2': cardCols == 6 }">
          <v-card class="dashboardCard hoverable" flat>
            <h3>{{ $t("messages.openBilling") }}</h3>
            <h1><span style="color:rgb(var(--v-theme-primary))">
                {{ dailyData.bill_count }}</span> <span style="color:rgb(var(--v-theme-success))"
                v-if="dailyData.bill_count_new">+{{ dailyData.bill_count_new }}</span>
            </h1>
          </v-card>
        </v-col>
        <v-col :cols="cardCols" class="pb-0" :class="{ 'px-2': cardCols != 6, 'pr-2': cardCols == 6 }">
          <v-card class="dashboardCard hoverable" flat
            @click="gotoCalendar($event, today, false)" @mousedown.middle="gotoCalendar($event, today, true)"
          >
            <h3>{{ $t("messages.appointmentsToday") }}</h3>
            <span>
              <h1 style="color:rgb(var(--v-theme-primary))">
                {{ dailyData.appointments_day_count }}</h1>
            </span>
          </v-card>
        </v-col>
        <v-col :cols="cardCols" class="pb-0 pl-2">
          <v-card class="dashboardCard hoverable" flat
            @click="gotoCalendar($event, today, false)" @mousedown.middle="gotoCalendar($event, today, true)">
            <h3>{{ $t("messages.appointmentsWeek") }}</h3>
            <span>
              <h1 style="color:rgb(var(--v-theme-primary))">
                {{ dailyData.appointments_week_count }}</h1>
            </span>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    

    <v-card class="mt-6" flat>
      <v-container fluid>
        <v-row>
          <v-col>
            <h3>{{ $t("messages.todos") }}:</h3>
          </v-col>
        </v-row>

        <v-row v-for="(ts, tsIndex) in dailyData.todos" :key="ts.id" class="hoverable">
          <v-col v-if="ts.retreat" cols="12" @click="gotoRetreat($event, ts.retreat.id, false)" @mousedown.middle="gotoRetreat($event, ts.retreat.id, true)">
            <b>{{ $t("messages.retreatSuggestions") }} ({{ ts.retreat.name }}, {{ ts.retreat.display_start_date }} - {{ ts.retreat.display_end_date }})</b><br>
            {{ ts.user.full_name }}
          </v-col>

          <v-col cols="12"  v-else @click="gotoCalendar($event, ts.date, false)" @mousedown.middle="gotoCalendar($event, ts.date, true)">
            <b>{{ $t("messages.timeSlotSuggestion") }}</b><br>
            {{ ts.display_date }} {{ ts.time_units[0].readable_start_time }} - {{ ts.time_units[ts.time_units.length -
              1].readable_end_time }}<br>
            <span v-for="(p, pIndex) in ts.patients">
              {{ p.user.full_name }}<span v-if="pIndex < ts.patients.length - 1" class="mr-1">,</span>
            </span>
          </v-col>

        <v-divider v-if="tsIndex < dailyData.todos.length - 1" />
        </v-row>

        <v-row v-if="!dailyData.todos || dailyData.todos.length == 0">
          <v-col>
            <p><i>{{ $t("messages.noItems") }}</i></p>
          </v-col>
        </v-row>

      </v-container>
    </v-card>

    <v-card class="mt-3" flat>
      <v-container fluid>
        <v-row>
          <v-col>
            <h3>{{ $t("messages.latestActivities") }}</h3>
          </v-col>
        </v-row>

        <v-row v-for="(action, actionIndex) in dailyData.actions" :key="action.id">
          <v-col cols="auto" style="display: flex; align-items: center;">
              <v-icon v-if="action.user" size="xx-large" class="icon-transparency">
                mdi-account-group
            </v-icon>
            <v-icon v-if="action.bill" size="xx-large" class="icon-transparency">
                mdi-currency-eur             
            </v-icon>
            <v-icon v-if="action.user_to_timeslot" size="xx-large" class="icon-transparency">
                mdi-calendar-account              
            </v-icon>
            </v-col>
          <v-col cols="auto">
            {{ action.display_created }}<br>
            <span v-if="action.user">
              {{ action.user.full_name }}
            </span>
            <span v-if="action.bill">
              Bill, todo
            </span>
            <span v-if="action.user_to_timeslot">
              {{ action.user_to_timeslot.user?.full_name }}, {{ action.user_to_timeslot.time_slot.display_date }} {{
                action.user_to_timeslot.time_slot.time_units[0].readable_start_time }} - {{
                action.user_to_timeslot.time_slot.time_units[action.user_to_timeslot.time_slot.time_units.length -
              1].readable_end_time }}
            </span>
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-chip :color="colors[action.type]">
              {{ $t("constants.action_type_" + action.display_type) }}
            </v-chip>
          </v-col>
          <v-divider v-if="actionIndex < dailyData.actions.length - 1" />
        </v-row>

        <v-row v-if="!dailyData.actions || dailyData.actions.length == 0">
          <v-col>
            <p><i>{{ $t("messages.noItems") }}</i></p>
          </v-col>
        </v-row>

      </v-container>
    </v-card>
    <!-- 
    <v-card class="mt-4">
      <v-container fluid>
        <v-row>
          <v-col>
            <h3>{{ $t("messages.quickActions") }}</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col :cols="actionCols">
            <v-card flat class="actionCard">
              <v-icon color="primary" class="mr-4">mdi-plus</v-icon> {{ $t("basics.new", { type: $t("basics.course") })
              }}
            </v-card>
          </v-col>

          <v-col :cols="actionCols">
            <v-card flat class="actionCard">
              <v-icon color="primary" class="mr-4">mdi-plus</v-icon> {{ $t("basics.new", { type: $t("basics.patient") })
              }}
            </v-card>
          </v-col>

          <v-col :cols="actionCols">
            <v-card flat class="actionCard">
              <v-icon color="primary" class="mr-4">mdi-plus</v-icon> {{ $t("basics.new", {
                type: $t("basics.accounting")
              }) }}
            </v-card>
          </v-col>

          <v-col :cols="actionCols">
            <v-card flat class="actionCard">
              <v-icon color="primary" class="mr-4">mdi-plus</v-icon> {{ $t("basics.new", {
                type:
                  $t("basics.appointment")
              }) }}
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card> -->

    <LoadingScreenVue :loading="loading" />
  </div>
</template>

<script>

export default {
  name: "dashboard",

  data() {
    return {
      dailyData: undefined,

      today: this.$moment(new Date()).format("YYYY-MM-DD"),
      displayDate: this.$moment(new Date()).format("DD.MM.YYYY"),
      weekday: new Date().getDay(),

      loading: false,

      colors: [
        "rgb(var(--v-theme-success))",
        "rgb(var(--v-theme-warning))",
        "rgb(var(--v-theme-secondary))",
      ]
    };
  },

  components: {
  },

  computed: {
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 8;
        case "xl":
          return 8;
        case "xxl":
          return 8;
        default:
          return 8;
      }
    },
    actionCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
        case "xxl":
          return 6;
        default:
          return 6;
      }
    },
    cardCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 6;
        case "sm":
          return 6;
        case "md":
          return 6;
        case "lg":
          return 3;
        case "xl":
          return 3;
        case "xxl":
          return 3;
        default:
          return 3;
      }
    },
  },

  methods: {
    gotoUsers(event, newTab){
      event.stopPropagation()
      event.preventDefault()

      if(!this.$checkFunctionPermission(["user_list"])){
        return
      }

      if(newTab){
        window.open(
          "/backoffice/users/", 
          "_blank"
        )
      }
      else{
        this.$router.push(
          "/backoffice/users/"
        )
      }
    },
    gotoCalendar(event, date, newTab) {
      event.stopPropagation()
      event.preventDefault()

      if (!this.$checkFunctionPermission(["own_calendar_detail"])) {
        return
      }

      if(newTab){
        window.open(
          "/backoffice/calendar/own?date=" + date,
          "_blank"
        )
      }
      else{
        this.$router.push(
          "/backoffice/calendar/own?date=" + date
        )
      }

    },
    gotoRetreat(event, retreatID, newTab) {
      event.stopPropagation()
      event.preventDefault()

      if (!this.$checkFunctionPermission(["retreat_detail"])) {
        return
      }

      if(newTab){
        window.open(
          "/backoffice/products/retreat/" + retreatID,
          "_blank"
        )
      }
      else{
        this.$router.push(
          "/backoffice/products/retreat/" + retreatID,
        )
      }

    },
    fetchData() {
      this.loading = true

      this.axios.post(this.axios.defaults.baseURL + "user/daily/", {
        date: this.today
      })
        .then((resp) => {
          this.dailyData = resp.data
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
          this.loading = false

        })
    },
  },

  mounted() {
    this.fetchData()
  },
};
</script>
